<template>
  <el-menu
    :default-active="$route.name"
    @open="handleOpen"
    @close="handleClose"
    :collapse="isCollapse">
    <div
      v-for="(l, index) in links"
      :key="l.name">
      <div v-if="accessibilities.find(a => a === l.operationId) || l.name === 'troubleshooting' || role.name === 'zeus'">
        <el-submenu
          :index="`${index}`"
          v-if="l.hasOwnProperty('children')">
          <template slot="title">
            <i :class="`fas fa-${l.icon}`"></i>&nbsp;
            <span slot="title">{{ $t(`${l.name}`) }}</span>
          </template>
          <el-menu-item
            v-for="(child, i) in l.children"
            :index="`${index}_${i}`"
            :key="child.name">
            <router-link
              :to="{name: child.name}">
              <i :class="`fas fa-${child.icon}`"></i>
              {{ $t(`${child.name}`) }}
            </router-link>
          </el-menu-item>
        </el-submenu>
        <el-menu-item
          v-else
          :index="`${index}`">
          <router-link
            :to="{name: l.name}">
            <i :class="`fas fa-${l.icon}`"></i>
            {{ $t(`${l.name}`) }}
          </router-link>
        </el-menu-item>
      </div>
    </div>
  </el-menu>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      links: [
        {
          name: 'users',
          icon: 'user',
          operationId: 'list_domain_users'
        },
        {
          name: 'teams',
          icon: 'users',
          operationId: 'list_domain_teams'
        },
        {
          name: 'announcements',
          icon: 'bell',
          operationId: 'list_domain_announcements'
        },
        {
          name: 'trace_tokens',
          icon: 'link',
          operationId: 'list_trace_tokens'
        },
        {
          name: 'discounts',
          icon: 'percent',
          operationId: 'list_domain_discounts'
        },
        {
          name: 'plans',
          icon: 'list-ul',
          operationId: 'list_domain_plans'
        },
        {
          name: 'addons',
          icon: 'plus',
          operationId: 'list_domain_addons'
        },
        {
          name: 'troubleshooting',
          icon: 'bug',
          operationId: ''
        },
        {
          name: 'roles',
          icon: 'sitemap',
          operationId: ''
        },
        {
          name: 'operators',
          icon: 'headphones',
          operationId: 'list_domain_operators'
        },
        {
          name: 'templates',
          icon: 'file',
          operationId: 'list_domain_templates'
        },
        {
          name: 'add_content',
          icon: 'file-alt',
          operationId: 'create_domain_content'
        },
        {
          name: 'resources',
          icon: 'database',
          operationId: 'create_domain_content'
        },
        {
          name: 'add_source',
          icon: 'plus',
          operationId: 'create_domain_source'
        },
        {
          name: 'keywords',
          icon: 'key',
          operationId: 'list_domain_keyword'
        }
      ],
      isCollapse: false,
      methods: ['GET', 'POST', 'PATCH', 'PUT', 'DELETE'],
      accessibilities: [],
      loading: true
    }
  },
  computed: {
    ...mapGetters([
      'domainsPath',
      'roleId',
      'role'
    ])
  },
  methods: {
    ...mapActions([
      'handleRequest',
      'setTeamsPath',
      'setRole',
      'setRoles'
    ]),
    handleOpen () {},
    handleClose () {},
    toggleLoading () {
      this.loading = !this.loading
    },
    async getData () {
      await this.handleRequest({
        name: 'self',
        action: 'getAll',
        mutation: 'SET_SELF'
      })
      await this.handleRequest({
        name: `${this.domainsPath}/roles`,
        action: 'getAll'
      }).then(res => {
        this.setRoles(res)
        this.setRole(res.list.find(r => r.id.numberStr === this.roleId.numberStr))
        this.accessibilities = this.role.accessibilities.reduce((filtered, accessibilities) => {
          if (this.methods.indexOf(accessibilities.method) > -1) {
            filtered.push(accessibilities.operation_id)
          }
          return filtered
        }, [])
      })
        .finally(this.toggleLoading)
    }
  },
  created () {
    this.getData()
  }
}
</script>
